import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';

// ----------------------------------------------------------------------

// ============================================================
//    Axios : instance HTTP centralisée
// baseURL = HOST_API_KEY (config-global.ts)
// Intercepteur request : ajoute le Bearer JWT depuis localStorage
// Intercepteur response : normalize les erreurs
// ============================================================
const axiosInstance = axios.create({ baseURL: HOST_API_KEY });


axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
